import http from '@/utils/request'

/**
 * 获取七牛云上传token
 * @returns
 */
export const getToken = (data = {}) => {
  return http.post('/upload/get-token', data)
}
